import { render, staticRenderFns } from "./EtiquetasDisenador.vue?vue&type=template&id=0f058248&scoped=true&"
import script from "./EtiquetasDisenador.vue?vue&type=script&lang=js&"
export * from "./EtiquetasDisenador.vue?vue&type=script&lang=js&"
import style0 from "./EtiquetasDisenador.vue?vue&type=style&index=0&id=0f058248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f058248",
  null
  
)

export default component.exports